import type {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { AuthenticationResult } from '@azure/msal-browser';
import { LoadingTrackerService } from '@services/tracker/loading-tracker.service';
import type { Observable } from 'rxjs';
import { finalize, switchMap } from 'rxjs';
import { SKIP_LOADING } from 'src/app/app.config';
import { environment } from 'src/app/environments/environment';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class OutgoingInterceptor implements HttpInterceptor {
  private authService = inject(AuthenticationService);
  private trackerService = inject(LoadingTrackerService);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return this.authService
      .acquireToken(request, environment.B2E_scope, next)
      .pipe(
        switchMap((result: AuthenticationResult) => {
          const headers = request.headers.set(
            'Authorization',
            `Bearer ${result.accessToken}`,
          );
          const requestClone = request.clone({ headers });

          if (request.headers.has('X-Skip-Loading')) {
            return next.handle(requestClone);
          }

          if (!request.context.get(SKIP_LOADING)) {
            this.trackerService.inc();
          }

          return next
            .handle(requestClone)
            .pipe(finalize(() => this.trackerService.dec()));
        }),
      );
  }
}
